import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert, Row, Col } from 'react-bootstrap';
import { Input, Checkbox, FormActions, PhoneNumber } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import Dialog from '../common/components/Dialog';
import { withTranslation, Trans } from 'react-i18next';
import TimeZonePicker from '../common/components/TimeZonePicker';

const passwordMinLength = validators.minLength(6);

class RegistrationForm extends Component {
	constructor(props) {
		super(props);
		this.showTermsAndConditions = this.showTermsAndConditions.bind(this);
		this.showPhotoConsent = this.showPhotoConsent.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.handleReferralSourceChange = this.handleReferralSourceChange.bind(this);
		this.state = {
			showInfoDialog: false,
			infoMessage: '',
			infoTitle: '',
			referralSourceId: ''
		};
	}

	showTermsAndConditions() {
		const { termsAndConditions, t } = this.props;
		this.setState({
			showInfoDialog: true,
			infoMessage: termsAndConditions,
			infoTitle: t('FO_Register_TermsAndConditionsTitle')
		});
	}

	showPhotoConsent() {
		const { photoConsent, t } = this.props;
		this.setState({
			showInfoDialog: true,
			infoMessage: photoConsent,
			infoTitle: t('FO_Register_PhotoConsentTitle')
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const body = <div dangerouslySetInnerHTML={{ __html: this.state.infoMessage }} />;
		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={this.state.infoTitle} body={body} />;
	}

	handleReferralSourceChange(event, referralSourceId) {
		this.setState({ referralSourceId });
	}

	render() {
		const { error, handleSubmit, pristine, submitting, referralSourceTypes, cities, requireAddress, requirePostcode,
			countryCode, initialValues, from, timeZones, enableUserTimeZone, t } = this.props;

		// hack: t('FO_Parent_Title') in the Trans component forces translation of the component in the redux-form
		const termsAndConditionsLabel = <Trans i18nKey='FO_Register_TermsAndConditions' parent='span'>
			I agree with the <a style={{ cursor: 'pointer' }} onClick={this.showTermsAndConditions}>{t('FO_Parent_Title')}</a>
		</Trans>;

		const photoConsentLabel = <Trans i18nKey='FO_Parent_PhotoConsent' parent='span'>
			I <a style={{ cursor: 'pointer' }} onClick={this.showPhotoConsent}>{t('FO_Parent_Title')}</a> my child and carer to be filmed during classes and pictures to be used for training and advertising purposes.
		</Trans>;

		const infoDialog = this.renderInfoDialog();
		const isOtherReferralSource = parseInt(this.state.referralSourceId) === 99;

		const checkboxClass = 'icheckbox_minimal-grey bg';

		return (
			<div>
				<form onSubmit={handleSubmit} className='feedback-form'>
					{error && <Alert bsStyle='danger'>{error}</Alert>}
					<Row>
						<Col sm={6}>
							<Field name='firstName' component={Input} horizontal required type='text' label={t('FO_Parent_FirstName')} validate={validators.required} />
							<Field name='lastName' component={Input} horizontal required type='text' label={t('FO_Parent_LastName')} validate={validators.required} />
							<Field name='city' component={Input} componentClass='select' horizontal required label={t('FO_Parent_CentreLocation')} validate={validators.required}>
								<option />
								{cities.sort((a, b) => a.toUpperCase() < b.toUpperCase() ? -1 : 1).map(city => <option key={city} value={city}>{city}</option>)}
							</Field>
							<Field name='address' component={Input} horizontal required={requireAddress} type='text' label={t('FO_Parent_Address')} validate={requireAddress && validators.required} />
							<Field name='postcode' component={Input} horizontal required={requirePostcode} type='text' label={t('FO_Parent_Postcode')} validate={requirePostcode && validators.required} />
							<Field name='phoneNumber' component={PhoneNumber} defaultCountry={countryCode} horizontal required type='text' label={t('FO_Parent_PhoneNumber')} validate={validators.required} />
							<Field name='email' component={Input} horizontal required type='text' label={t('FO_Parent_Email')} validate={[validators.required, validators.email]} />
							<Field name='password' component={Input} horizontal required type='password' label={t('FO_Register_Password')} validate={[validators.required, passwordMinLength]} />
						</Col>
						<Col sm={6}>
							{enableUserTimeZone && <TimeZonePicker name='timeZone' horizontal required label={t('FO_Parent_TimeZone')} timeZones={timeZones} validate={validators.required} />}
							<Field name='referralSourceId' component={Input} componentClass='select' horizontal required label={t('FO_Parent_HowYouLearn')} onChange={this.handleReferralSourceChange} validate={validators.required} >
								<option />
								{referralSourceTypes.map(item => <option key={item.id} value={item.id}>{t(`ReferralSourceType_${item.name}`)}</option>)}
							</Field>
							{isOtherReferralSource && <Field name='howYouLearn' component={Input} horizontal componentClass='textarea' validate={validators.required} />}
							<Field name='agreeWithTermsAndConditions' component={Checkbox} horizontal required checkboxClass={checkboxClass} label='&nbsp;' staticLabel={termsAndConditionsLabel} type='checkbox' validate={validators.required} />
							<Field name='photoConsent' component={Checkbox} horizontal checkboxClass={checkboxClass} label='&nbsp;' staticLabel={photoConsentLabel} type='checkbox' />
							<Field name='marketingEmailConsent' component={Checkbox} horizontal checkboxClass={checkboxClass} label='&nbsp;' staticLabel={t('FO_Parent_MarketingEmailConsent')} type='checkbox' />
						</Col>
					</Row>
					<Row>
						<Col sm={6} smOffset={6}>
							<FormActions horizontal>
								<Button type='submit' disabled={pristine || submitting} className='btn btn-primary btn-auth'>
									{t('FO_Register_Continue')} <i className='fa fa-arrow-circle-right' />
								</Button>
								<div className='auth-link-wrapper'>
									<Link to={{ pathname: '/login', state: { from } }} className='auth-link'>{t('FO_Register_ExistingUser')}</Link>
								</div>
							</FormActions>
						</Col>
					</Row>
				</form>
				{infoDialog}
			</div>
		);
	}
}

RegistrationForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'registration', enableReinitialize: true })(withTranslation()(RegistrationForm));